export var isSelectionAutomatic = function(selection) {
    return (selection === null || selection === void 0 ? void 0 : selection.delivery_method) === 'automatic';
};
export var isSelectionManual = function(selection) {
    return (selection === null || selection === void 0 ? void 0 : selection.delivery_method) === 'manual';
};
